/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cp_Cmp_2_TInputs */

const en_cp_cmp_2_t = /** @type {(inputs: Cp_Cmp_2_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`6–10-month full-time curriculum, global certification, strict selection, 20-credit conversion.`)
};

const id_cp_cmp_2_t = /** @type {(inputs: Cp_Cmp_2_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kurikulum 6–10 bulan full-time, sertifikasi global, seleksi ketat, konversi 20 SKS.`)
};

/**
* | output |
* | --- |
* | "6–10-month full-time curriculum, global certification, strict selection, 20-credit conversion." |
*
* @param {Cp_Cmp_2_TInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cp_cmp_2_t = /** @type {((inputs?: Cp_Cmp_2_TInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cp_Cmp_2_TInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cp_cmp_2_t(inputs)
	return en_cp_cmp_2_t(inputs)
});